import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/dto.js';
import {
  ArtificialSeatLockingSettings,
} from '../../models/serializable/artificial-seat-locking-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ArtificialSeatLockingComponent extends Component {
  static readonly TYPE_ID = 'ca40f6f3c5684ffeabb830def9789fe6';

  private constructor(
    public readonly settings: ArtificialSeatLockingSettings,
  ) {
    super();
  }

  get $typeId(): string {
    return ArtificialSeatLockingComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static create(args: {
    settings: ArtificialSeatLockingSettings,
  }): ArtificialSeatLockingComponent {
    return new ArtificialSeatLockingComponent(
        args.settings,
    );
  }

  static fromMap(data: SerializedData, context: SerializationContext): ArtificialSeatLockingComponent {
    return ArtificialSeatLockingComponent.create({
      settings: context.fromData(MapUtils.getRecord(data, 'settings')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      settings: context.toData(this.settings),
    };
  }

  clone(): this {
    return new ArtificialSeatLockingComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class ArtificialSeatLockingComponentBuilder extends DataModelBuilder<ArtificialSeatLockingComponent> {
  build(context: SerializationContext, data: SerializedData): ArtificialSeatLockingComponent {
    return ArtificialSeatLockingComponent.fromMap(data, context);
  }
}
